import React, { Component } from 'react';

import Dialog from 'material-ui/Dialog';
import './alert.css';
import DriverShift from '../Parking/DriverShift';
import DriverComments from '../Parking/DriverComments';

class DriverSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newComment: '',
    };
  }

  writeComment = val => this.setState({ newComment: val });

  submitComment = () => {
    const body = {
      comment: this.state.newComment,
      username: this.props.username,
      visible: true,
      user_id: this.props.booking.user_id,
    };
    this.props.postComment(body);
    this.props.closeDialog();
    this.setState({ newComment: '' });
  };

  renderSubmitButton = () =>
    this.state.newComment ? (
      <button type="button" className="alert-button" onClick={() => this.submitComment()}>
        SUBMIT
      </button>
    ) : null;

  render() {
    const { closeDialog, isDialogOpen, booking } = this.props;
    return (
      <Dialog
        actions={
          <div>
            <div className="driver-summary-layout">
              <DriverShift booking={booking} />
              <DriverComments booking={booking} newComment={this.state.newComment} writeComment={this.writeComment} />
            </div>
            {this.renderSubmitButton()}
            <button type="button" className="alert-button" onClick={closeDialog}>
              CLOSE
            </button>
          </div>
        }
        open={isDialogOpen}
        paperProps={{ style: { borderRadius: '4px' } }}
      />
    );
  }
}

export default DriverSummary;



// WEBPACK FOOTER //
// ./src/components/Alert/DriverSummary.js